import { FC, useEffect, useState } from "react";
import {
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";
import { IPricingItem } from "../pricingList";
import "./PricingItem.css";
import { FaCheckCircle } from "react-icons/fa";
import BoxShadowContainer from "components/UIComponents/BoxShadowContainer";
import CustomHeading from "components/UIComponents/Typography/Heading";
import { BuySubscriptionButton } from "../PricingTable";
import { RequestMethod, RequestName } from "hooks/api/apiHookTypes";
import useApiRequest from "hooks/api/useApiHook";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

export const PricingItem: FC<IPricingItem> = (item) => {
  const [balance, setBalance] = useState(null);
  const apiKey = useSelector((state: RootState) => state.apiKey.apiKey);
  const currentSubscription = useSelector((state: RootState) => state.userData.subscription);
  const { data, loading, error } = useApiRequest({
    apiToken: apiKey,
    method: RequestMethod.GET,
    name: RequestName.GET_BALANCE,
  });

  useEffect(() => {
    if (data) {
      setBalance(data.balance);
    }
  }, [data, error, loading]);

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <BoxShadowContainer className="pricing-item">
      <div className="pricing-item-heading"></div>
      <div className="pricing-item-body">
        <ul className="pricing-item-options">
          <li>
            <CustomHeading>
              <FormattedMessage id={`${item.name}PlanText`} />
            </CustomHeading>
          </li>
          <li className="pricing-inline-list-element">
            <Text fontSize={22} fontWeight="bold">
              ${item.price}
            </Text>
            <Text fontSize={12}>
              /<FormattedMessage id="MonthText" />
            </Text>
          </li>
          <li className="pricing-inline-list-element lookups">
            <Text fontSize={22}>
              {item.lookupsTotal === "infinite" ? "∞" : item.lookupsTotal}
            </Text>
            <Text fontSize={12}>
              <FormattedMessage id="LookupsPerMonthText" />{" "}
            </Text>
          </li>
          <li>
            <ul className="pricing-item-options benefits">
              {item.benefits.map(
                (benefit) =>
                  item.benefits.indexOf(benefit) < 5 && (
                    <li>
                      <FaCheckCircle />
                      <FormattedMessage id={`${benefit}PricingText`} />
                    </li>
                  )
              )}
              {item.id > 0 && (
                <Text onClick={onOpen} cursor="pointer" textDecor="underline">
                  <FormattedMessage id="SeeAllText" />
                </Text>
              )}
            </ul>
          </li>
        </ul>
      </div>
      {
        (!currentSubscription && item.id > 1) ||
          (currentSubscription && item.id > currentSubscription) ? (
          <BuySubscriptionButton item={item} balance={balance} currentSubscription={currentSubscription} />
        ) : (
          (item.id === 1) ? (
            <Flex height="35px" alignItems="center">
              <Text mr={1} fontSize={16} fontWeight="bold">
                ${item.price}
              </Text>
              /<FormattedMessage id="MonthText" />
            </Flex>
          ) : (
            (currentSubscription && currentSubscription === item.id) ? (
              <Text fontWeight={900}>Your current plan</Text>
            ) : null
          )
        )

      }
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <ul className="pricing-item-options modal">
              {item.benefits.map((benefit) => (
                <li>
                  <FaCheckCircle />
                  <FormattedMessage id={`${benefit}PricingText`} />
                </li>
              ))}
            </ul>
          </ModalBody>
        </ModalContent>
      </Modal>
    </BoxShadowContainer>
  );
};
